var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import ContenidoVentana from '../contenido-ventana';
import VisorImagenes from '../../visor-imagenes/components/visor-imagenes';
import AreaImagen from '../../visor-imagenes/components/area-imagen';
import BotoneraAreaImagenVisor from '../../visor-imagenes/components/botonera-area-imagen-visor';
import PieBotoneraVisor from '../../visor-imagenes/components/pie-botonera-visor';
import BotoneraAreaImagenVisorIzquierda from '../../visor-imagenes/components/botonera-area-imagen-visor-izquierda';
import ContenidosVisor from '../../visor-imagenes/components/contenidos-visor';
import AreaMiniaturas from '../../visor-imagenes/components/area-miniaturas';
import Precarga from '../../precarga'; // import BotoneraAreaImagenVisorDerecha from './botonera-area-imagen-visor-derecha'

import BotonSiguiente from './boton-siguiente';
import BotonAudio from './boton-audio';
import * as Util from '../../util';
var ContenidoTipoFlashcards = (_temp = _class = function (_React$Component) {
  _inherits(ContenidoTipoFlashcards, _React$Component);

  function ContenidoTipoFlashcards(props) {
    _classCallCheck(this, ContenidoTipoFlashcards);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleSiguiente = function () {
      var numFc = _this.state.numFc;

      _this.setState({
        numFc: numFc + 1
      });
    };

    _this.handleAnterior = function () {
      var numFc = _this.state.numFc;

      _this.setState({
        numFc: numFc - 1
      });
    };

    _this.handleMiniatura = function (numFc) {
      _this.setState({
        numFc: numFc
      });
    };

    _this.handleBotonTexto = function () {
      var textoVisible = _this.state.textoVisible;

      _this.setState({
        textoVisible: !textoVisible
      });

      _this.setState({
        textoMayusculasVisible: false
      });
    };

    _this.handleBotonTextoMayusculas = function () {
      var textoMayusculasVisible = _this.state.textoMayusculasVisible;

      _this.setState({
        textoMayusculasVisible: !textoMayusculasVisible
      });

      _this.setState({
        textoVisible: false
      });
    };

    _this.handleBotonImagenFoto = function () {
      _this.setState({
        carpetaImg: 'img1'
      });
    };

    _this.handleBotonImagenColor = function () {
      _this.setState({
        carpetaImg: 'img2'
      });
    };

    _this.handleBotonImagenLinea = function () {
      _this.setState({
        carpetaImg: 'img3'
      });
    };

    _this.state = {
      txt: null,
      grp: null,
      flashcards: '',
      fcs: [],
      numFc: 0,
      textoVisible: false,
      textoMayusculasVisible: false,
      carpetaImg: props.carpetaImgInicial
    };
    return _this;
  }

  ContenidoTipoFlashcards.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        txtFile = _props.txtFile,
        grpFile = _props.grpFile;
    var _state = this.state,
        txt = _state.txt,
        grp = _state.grp;

    if (txt === null) {
      Util.fetch(txtFile).then(function (response) {
        return response.json();
      }).then(function (json) {
        return _this2.setState({
          txt: json.data
        });
      }).catch(function (reason) {
        return window.console.error('Error cargando ' + txtFile, reason);
      });
    }

    if (grp === null) {
      Util.fetch(grpFile).then(function (response) {
        return response.json();
      }).then(function (json) {
        return _this2.setState({
          grp: json.data
        });
      }).catch(function (reason) {
        return window.console.error('Error cargando ' + grpFile, reason);
      });
    }
  };

  ContenidoTipoFlashcards.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var flashcards = this.props.flashcards;
    var _state2 = this.state,
        txt = _state2.txt,
        grp = _state2.grp;

    if (txt && grp && this.state.flashcards !== flashcards) {
      var params = flashcards.split(':')[1].split('.');

      if (params.length === 3) {
        // formato: swf,FLASHCARDS:unidad.bloque.index
        var _params$map = params.map(Number),
            numUnidad = _params$map[0],
            numBloque = _params$map[1],
            numFc = _params$map[2];

        var fcs = grp.BLOQUES[numUnidad - 1].BLOQUE[numBloque - 1].datos.split(',');
        this.setState({
          flashcards: flashcards,
          fcs: fcs,
          numFc: numFc
        });
      } else if (params.length === 2) {
        // formato: swf,FLASHCARDS:unidad.index (index = nº de la FC inicial)
        var _params$map2 = params.map(Number),
            _numUnidad = _params$map2[0],
            _numFc = _params$map2[1];

        var _fcs = grp.TEMAS[_numUnidad - 1].datos.split(',');

        this.setState({
          flashcards: flashcards,
          fcs: _fcs,
          numFc: _numFc
        });
      } else if (params.length === 1 && params[0].split(';').length > 1) {
        // formato: swf,FLASHCARDS:aaaa;bbbb;cccc;dddd;eeee...
        // donde aaaa, bbbb, cccc, dddd, eeee... son numeros de flashcards                
        var _fcs2 = params[0].split(';');

        this.setState({
          flashcards: flashcards,
          fcs: _fcs2,
          numFc: 1
        });
      } else if (params.length === 1 && params[0].split('+').length > 1) {
        // formato: swf,FLASHCARDS:unidad 1 + unidad 2 + ...
        var uds = params[0].split('+');
        var _fcs3 = [];

        for (var i = 0; i < uds.length; i++) {
          _fcs3 = _fcs3.concat(grp.TEMAS[parseInt(uds[i], 10) - 1].datos.split(','));
        }

        this.setState({
          flashcards: flashcards,
          fcs: _fcs3,
          numFc: 1
        });
      } else if (params.length === 1 && params[0].length === 4) {
        // formato: swf,FLASHCARDS:aaaa
        // donde aaaa = id de una única FC
        var _fcs4 = [params[0]];
        this.setState({
          flashcards: flashcards,
          fcs: _fcs4,
          numFc: 1
        });
      } else if (params.length === 1) {
        // formato: swf,FLASHCARDS:unidad
        var _numUnidad2 = parseInt(params[0], 10);

        var _fcs5 = grp.TEMAS[_numUnidad2 - 1].datos.split(',');

        this.setState({
          flashcards: flashcards,
          fcs: _fcs5,
          numFc: 1
        });
      }
    }
  };

  ContenidoTipoFlashcards.prototype.getTexto = function getTexto(fc) {
    var txt = this.state.txt;

    if (!fc || !txt) {
      return '';
    }

    var _txt$0$IMG$find = txt[0].IMG.find(function (item) {
      return item.id === String(Number(fc.substring(1, 4)));
    }),
        texto = _txt$0$IMG$find.texto;

    return texto;
  };

  ContenidoTipoFlashcards.prototype.render = function render() {
    var _this3 = this; // const { versionImagen } = this.props


    var _state3 = this.state,
        carpetaImg = _state3.carpetaImg,
        fcs = _state3.fcs,
        numFc = _state3.numFc,
        textoVisible = _state3.textoVisible,
        textoMayusculasVisible = _state3.textoMayusculasVisible,
        flashcards = _state3.flashcards;
    var vinetas = fcs.map(function (fc, index) {
      return {
        src: 'contenido/FCs/flashcards/min1/' + fc.substring(1, 4) + '.png',
        vinculo: index + 1
      };
    });
    var fc = numFc > 0 ? fcs[numFc - 1] : null;
    var texto = this.getTexto(fc); //  (txt && numFc > 0) ? txt[0].IMG[numFc - 1].texto : ''

    return React.createElement(ContenidoVentana, null, !flashcards && React.createElement(Precarga, null), flashcards && React.createElement(VisorImagenes, null, React.createElement(AreaImagen, null, React.createElement(BotoneraAreaImagenVisorIzquierda, {
      paso: numFc,
      onBotonAnteriorClick: this.handleAnterior // txtNumVineta={ numFc } 

    }, React.createElement('div', {
      className: 'botonImagenFoto' + (carpetaImg === 'img1' ? ' activa' : ''),
      onClick: this.handleBotonImagenFoto
    }), React.createElement('div', {
      className: 'botonImagenColor' + (carpetaImg === 'img2' ? ' activa' : ''),
      onClick: this.handleBotonImagenColor
    }), React.createElement('div', {
      className: 'botonImagenLinea' + (carpetaImg === 'img3' ? ' activa' : ''),
      onClick: this.handleBotonImagenLinea
    })), fc && React.createElement(ContenidosVisor, {
      src: 'contenido/FCs/flashcards/' + carpetaImg + '/' + fc.substring(1, 4) + '.png',
      versionImagen: '',
      paso: numFc,
      texto: textoVisible ? texto : textoMayusculasVisible ? texto.toUpperCase() : '',
      claseTexto: textoMayusculasVisible ? ' fuenteMayusculas' : ''
    }, this.props.children), React.createElement(BotoneraAreaImagenVisor, null, React.createElement(BotonAudio, {
      src: 'contenido/FCs/flashcards/aud' + fc.substring(0, 1) + '/' + fc.substring(1, 4) + '.mp3'
    }), React.createElement('div', {
      className: 'botonTextoVisorImagenes' + (textoVisible ? ' activa' : ''),
      onClick: this.handleBotonTexto
    }), React.createElement('div', {
      className: 'botonMayusculasVisorImagenes' + (textoMayusculasVisible ? ' activa' : ''),
      onClick: this.handleBotonTextoMayusculas
    }), React.createElement(PieBotoneraVisor, null, React.createElement(BotonSiguiente, {
      activo: numFc < fcs.length,
      onClick: function onClick() {
        return _this3.handleMiniatura(numFc + 1);
      }
    })))), React.createElement(AreaMiniaturas, {
      vinetas: vinetas,
      paso: numFc,
      onBoton: this.handleMiniatura
    })));
  };

  return ContenidoTipoFlashcards;
}(React.Component), _class.defaultProps = {
  hayBotonTexto: false,
  carpetaImgInicial: 'img1',
  txtFile: 'contenido/FCs/flashcards/txt.json',
  grpFile: 'contenido/FCs/flashcards/grp.json',
  numFc: 1
}, _temp);
ContenidoTipoFlashcards.propTypes = process.env.NODE_ENV !== "production" ? {
  flashcards: t.string,
  carpetaImgInicial: t.string,
  txtFile: t.string,
  grpFile: t.string,
  children: t.any
} : {};
export default ContenidoTipoFlashcards;